module.exports = __webpack_public_path__ + "media/fastweb_college_scholarships_app/appstore-lrg-apple-fcd72b71.png";